import isEmpty from '../isEmpty'

const isObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && value.constructor === Object

const isEmptyValue = (value: unknown): boolean => {
  if (!value) return true

  if (
    typeof value === 'string' ||
    typeof value === 'number' ||
    Array.isArray(value) ||
    isObject(value)
  ) {
    return isEmpty(value)
  }

  return false
}

const removeEmptyValuesFromObject = <T extends Record<string, unknown>>(
  obj: T,
  recursive = true,
): Record<string, unknown> => {
  return Object.entries(obj).reduce<Record<string, unknown>>(
    (result, [key, value]) => {
      const recurseChildObject = recursive && isObject(value)

      const updatedValue = recurseChildObject
        ? removeEmptyValuesFromObject(value)
        : value

      if (isEmptyValue(updatedValue)) return result
      Object.defineProperty(result, key, {
        value: updatedValue,
        enumerable: true,
        configurable: true,
        writable: true,
      })
      return result
    },
    {},
  )
}

export default removeEmptyValuesFromObject
